/**
 * RDRC Collections Page — Interactive Behaviors
 * 1. Filter bar scroll shadow
 * 2. Filter pill toggle
 * 3. Grid view toggle (3/4 columns)
 * 4. Grid card scroll reveal via IntersectionObserver
 * 5. Shopify section:load re-init
 */
(function () {
  'use strict';

  var gridObserver = null;

  function init() {
    var staleEmpty = document.querySelector('.rdrc-grid__filter-empty');
    if (staleEmpty) staleEmpty.remove();
    initFilterBarShadow();
    initFilterPills();
    initViewToggle();
    initGridReveal();
    updateCount();
  }

  /* ── 1. Filter bar scroll shadow ─────────────── */
  function initFilterBarShadow() {
    var bar = document.querySelector('.rdrc-filter-bar');
    if (!bar) return;

    function check() {
      var rect = bar.getBoundingClientRect();
      var headerH = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 84;
      bar.classList.toggle('scrolled', rect.top <= headerH + 1);
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ── 2. Filter pill toggle ───────────────────── */
  function initFilterPills() {
    var pills = document.querySelectorAll('.rdrc-filter-bar__pill');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-pressed', 'true');

        var category = pill.getAttribute('data-category');
        filterGrid(category);
      });
    });
  }

  function filterGrid(category) {
    var cards = document.querySelectorAll('.rdrc-grid__card:not(.rdrc-grid__empty)');
    var count = 0;
    var grid = document.querySelector('.rdrc-grid');

    cards.forEach(function (card) {
      if (!category || category === 'all') {
        card.style.display = '';
        card.classList.add('visible');
        count++;
      } else {
        var cardCategory = (card.getAttribute('data-category') || '').toLowerCase();
        if (cardCategory === category.toLowerCase()) {
          card.style.display = '';
          card.classList.add('visible');
          count++;
        } else {
          card.style.display = 'none';
          card.classList.remove('visible');
        }
      }
    });

    /* Show/hide empty state for zero results */
    var emptyEl = document.querySelector('.rdrc-grid__filter-empty');
    if (count === 0 && grid) {
      if (!emptyEl) {
        emptyEl = document.createElement('div');
        emptyEl.className = 'rdrc-grid__empty rdrc-grid__filter-empty';
        emptyEl.innerHTML = '<p class="rdrc-grid__empty-text">No collections match this filter.</p>';
        grid.appendChild(emptyEl);
      }
      emptyEl.style.display = '';
    } else if (emptyEl) {
      emptyEl.style.display = 'none';
    }

    updateCount(count);
  }

  function updateCount(count) {
    var countEl = document.querySelector('.rdrc-filter-bar__count');
    if (!countEl) return;
    if (typeof count === 'undefined') {
      count = document.querySelectorAll('.rdrc-grid__card:not(.rdrc-grid__empty):not([style*="display: none"])').length;
    }
    countEl.textContent = count + ' Collection' + (count !== 1 ? 's' : '');
  }

  /* ── 3. View toggle ──────────────────────────── */
  function initViewToggle() {
    var btns = document.querySelectorAll('.rdrc-filter-bar__view-btn');
    var grid = document.querySelector('.rdrc-grid');
    if (!btns.length || !grid) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var cols = btn.getAttribute('data-cols');
        if (cols === '3') {
          grid.classList.add('rdrc-grid--3col');
        } else {
          grid.classList.remove('rdrc-grid--3col');
        }
      });
    });
  }

  /* ── 4. Grid card scroll reveal ──────────────── */
  function initGridReveal() {
    if (gridObserver) {
      gridObserver.disconnect();
      gridObserver = null;
    }

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.rdrc-grid__card').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    gridObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          gridObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.rdrc-grid__card').forEach(function (el) {
      gridObserver.observe(el);
    });
  }

  /* ── 5. Init + Shopify editor reload ─────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
